<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <notification-dropdown />

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{
                getUserData != null
                  ? `${getUserData.firstName} ${getUserData.lastName}`
                  : $t("Please Login")
              }}
            </p>
            <!-- <span class="user-status">{{ authType }}</span> -->
          </div>
          <b-avatar
            v-if="getUserData"
            size="40"
            variant="light-primary"
            badge
            :src="getUserData.image"
            class="badge-minimal"
            badge-variant="success"
          />
          <b-avatar
            v-else
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>{{ $t("Profile") }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          v-if="getUserData != null"
          link-class="d-flex align-items-center"
          @click="selectProfile"
        >
          <feather-icon
            size="16"
            icon="ArrowLeftIcon"
            class="mr-50"
          />
          <span>{{ $t("Select Profile") }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="getUserData == null"
          link-class="d-flex align-items-center"
          @click="login"
        >
          <feather-icon
            size="16"
            icon="LogInIcon"
            class="mr-50"
          />
          <span>{{ $t("Login") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{
                navbarTitle
              }}
            </p>
            <span class="user-status">{{ $t(menuService.toUpperCase().replace('-',' ')) }}</span>
          </div>
          <b-avatar
            v-if="profilePartnerData.image !== null"
            size="40"
            variant="light-primary"
            badge
            :src="profilePartnerData.image"
            class="badge-minimal"
            badge-variant="success"
          />
          <b-avatar
            v-else
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>{{ $t("Profile") }}</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>{{ $t("Inbox") }}</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>{{ $t("Task") }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="chatPage"
        >
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>{{ $t("Chat") }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />
        <b-dropdown-item
          v-if="getUserData != null"
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t("Logout") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import {
  // eslint-disable-next-line no-unused-vars
  initialAbility, storeGroceryAbility, storeFoodAbility, storeQueueAbility, driverDeliveryAbility, driverCallAbility, servicesAbility,
} from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import Locale from '@/layouts/components/app-navbar/Locale.vue'
import NotificationDropdown from '@/layouts/components/app-navbar/NotificationDropdown.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import store from '@/store'
import axios from '@axios'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    DarkToggler,

    // Locale
    Locale,
    NotificationDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    menuService() {
      return store.state.appConfig.menuService
    },
    navbarTitle() {
      return store.state.appConfig.navbarTitle
    },
    getUserData() {
      return localStorage.getItem('userData') != null
        ? JSON.parse(localStorage.getItem('userData'))
        : null
    },
    profilePartnerData() {
      return localStorage.getItem('profilePartnerData') != null
        ? JSON.parse(localStorage.getItem('profilePartnerData'))
        : null
    },
  },
  methods: {
    getAbility(item, path) {
      axios.get(`api/web/getAbility/get?type=${item}`)
        .then(response => {
        // console.log(response)
          this.$ability.update(response.data.data)
          localStorage.setItem('ability', JSON.stringify(response.data.data))
          this.$router.replace({ name: path })
        })
      // eslint-disable-next-line no-unused-vars
        .catch(error => {
        // console.log(error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        })
    },
    chatPage() {
      // Redirect to login page
      if (this.menuService === 'e-commerce') {
        this.$router.push({ name: 'e-commerce-chat' })
      } else if (this.menuService === 'company') {
        this.$router.push({ name: 'company-chat' })
      } else if (this.menuService === 'franchise') {
        this.$router.push({ name: 'franchise-chat' })
      } else if (this.menuService === 'root') {
        this.$router.push({ name: 'root-chat' })
      }
    },
    selectProfile() {
      // Redirect to login page
      this.$router.replace({ name: 'select-profile' })
    },
    logout() {
      // const role = localStorage.getItem('role') ? localStorage.getItem('role') : ''
      useJwt.logout()

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.replace({ name: 'auth-login' })
      store.commit('appConfig/UPDATE_MENU_SERVICE', '')
      store.commit('appConfig/RESET_NAVBAR_TITLE')
      store.commit('appConfig/RESET_NAVBAR_IMAGE')
    },
    login() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      useJwt.logout()

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.replace({ name: 'auth-login' })
      store.commit('appConfig/UPDATE_MENU_SERVICE', '')
      store.commit('appConfig/RESET_NAVBAR_TITLE')
      store.commit('appConfig/RESET_NAVBAR_IMAGE')
    },
  },
}
</script>
